/* eslint-disable no-nested-ternary */
import PeopleWidgetWithOutHolo from 'Components/common/components/PeopleWidgetWithOutHolo';
import SkeletonCustom from 'Components/common/skeleton/SkeletonCustom';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { PersonalityTypes } from 'Types/PersonTypes';
import { COMPANY_NEWS_ROUTE, PERSONALITY_INSIGHTS_ROUTE, translateSkipAreas } from 'Utils/Constants';
import { backgroundColorParsing } from 'Utils/UtilityFunctions';
import {
  boxShadow, maxWidth, primaryColor, retina, secondaryFont, wMedium,
} from 'Utils/utilsStyle';

const Wrapper = styled.div`
  box-shadow: ${boxShadow};
  border-radius: 10px;
  background: #fff;
  display: flex;
  align-items: center;
  padding: 10px 15px;
  margin-bottom: 10px;
  height: 80px;
  .stats-side {
    display: flex;
    align-items: center;
    justify-content: space-between;
    min-width: calc(100% - 80px);
    margin-left: 15px;
    @media all and (max-width: ${maxWidth}) , ${retina} {
      min-width: calc(100% - 60px);
    }
   .tip {
     width: 100%;
    .title {
     cursor: pointer;
     font-family: ${secondaryFont};
     font-size: 18px;
     color: #000;
     margin-bottom: 0px;
     letter-spacing: -0.38px;
     line-height: 23px;
     @media all and (max-width: ${maxWidth}) , ${retina} {
      font-size: 14px;
     }
    }
    .download-profile {
     line-height: 24px;
     color: ${primaryColor};
     font-size: 14px;
     letter-spacing: -0.29px;
     line-height: 24px;
     margin-bottom: 0px;
     font-weight: ${wMedium};
     @media all and (max-width: ${maxWidth}) , ${retina} {
      font-size: 12px;
      line-height: 14px;
     }
    }
   }
    .count {
     color: ${primaryColor};
     font-family: ${secondaryFont};
     font-size: 20px;
     letter-spacing: -0.42px;
     font-weight: ${wMedium};
    }
  }
`;

const CompanyLogo = styled.div<{ logo: string }>`
  background-image: url(${(props) => props.logo});  
  background-size: cover;
  background-position: center;
  height: 60px;
  width: 60px;
  cursor: pointer;
  @media all and (max-width: ${maxWidth}) , ${retina} {
    height: 30px;
    width: 30px;  
  }
`;

type Props = {
  image: string,
  title: string,
  downloadsProfile: number,
  count: number,
  personWidget: boolean,
  personId?: number,
  companyId?: number,
  personality: PersonalityTypes[],
  loading?: boolean,
} | typeof defaultProps;

const defaultProps = {
  image: 'https://picsum.photos/200/300',
  title: 'Apple',
  downloadsProfile: 0,
  count: 0,
  personWidget: false,
  personId: 0,
  companyId: 0,
  personality: [],
  loading: false,
};

const EngagementProfile = function EngagementProfile(props: Props) {
  const {
    image,
    title,
    downloadsProfile,
    count,
    personWidget,
    personality,
    personId,
    companyId,
    loading,
  } = props;
  const navigate = useNavigate();

  const navigateTo = () => {
    let url = '';
    if (personId) url = `${PERSONALITY_INSIGHTS_ROUTE}${personId}&personType=${'EXECUTIVE'}`;
    else if (companyId) url = `${COMPANY_NEWS_ROUTE}${companyId}`;
    if (url?.length) {
      navigate(url);
    }
  };

  return (
    <Wrapper>
      <div className="logo-side">
        {loading
          ? <SkeletonCustom width="40px" height="40px" diameter="50%" margin="0px" />
          : personWidget
            ? (
              <PeopleWidgetWithOutHolo
                diameter="54px"
                diameterSm="44px"
                diameterXsm="44px"
                ringPadding="2px"
                ringPaddingSm="2px"
                wrapperColor={backgroundColorParsing(personality)}
                logo={image}
                persona="#F0B520"
                personId={personId}
                margin="4px 0px"
              />
            )
            : (
              <CompanyLogo
                logo={image}
                onClick={navigateTo}
                onKeyPress={navigateTo}
                aria-hidden="true"
              />
            )}
      </div>
      <div className="stats-side">
        <div className="tip">
          {loading ? (
            <span className="resolution-fix engagement-text">
              <SkeletonCustom width="240px" height="20px" margin="0px" />
            </span>
          )
            : (
              <h6
                className="title text-truncate-one-line"
                onClick={navigateTo}
                onKeyPress={navigateTo}
                aria-hidden="true"
              >
                {title}
              </h6>
            )}
          {loading ? (
            <span className="resolution-fix engagement-text">
              <SkeletonCustom width="200px" height="18px" margin="0px" />
            </span>
          )
            : <p className="download-profile text-truncate-one-line">{`Profile Downloads: ${downloadsProfile}`}</p>}
        </div>
        <div className={`count ${translateSkipAreas}`}>
          {loading ? <SkeletonCustom width="30px" height="30px" margin="0px" /> : count}
        </div>
      </div>
    </Wrapper>
  );
};

EngagementProfile.defaultProps = defaultProps;
export default EngagementProfile;
